import type { OfferedPlan } from "@amtana/billing-contract";

// The paid plans the website shows and its credit helper weighs (D1378). The website reads no
// flags, so it cannot follow an organization's `more-plans`; it shows Free and Starter alone, and
// Growth and Enterprise stay in the contract and in this family's words. To show them later, list
// them here in the contract's order, `["starter", "growth", "enterprise"]` (`OFFERED_PLANS`): the
// cards, the structured data, the meta description and the helper all read this one list.
export const WEBSITE_PLANS: readonly OfferedPlan[] = ["starter"];
